import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/stocks/StocksClient.tsx");
